import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { RouterModule } from "@angular/router";
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RedesEmpresaComponent } from "./redesEmpresa.component";
import { RedesEmpresaServices } from "./redeEmpresa.service";
import { DataTableModule } from "angular2-datatable";


@NgModule({
    declarations: [RedesEmpresaComponent],
    imports: [BrowserModule, HttpModule, FormsModule, BrowserAnimationsModule, RouterModule, DataTableModule],
    exports: [RedesEmpresaComponent],
    providers: [RedesEmpresaServices]
})

export class RedesEmpresaModule { }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/vamEmpresa/redes/redesEmpresa.module.ts